/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useState } from 'react';

export const DrawerContext = createContext({});
export const DrawerProvider = ({children}) => {
  const [ openDrawer, setOpenDrawer ] = useState(false);
  const [ formPanel, setFormPanel ] = useState('register');
  const [ emailToRecoverPass, setEmailToRecoverPass ] = useState('');

  return (
    <DrawerContext.Provider
      value={{
        emailToRecoverPass,
        formPanel,
        openDrawer,
        setEmailToRecoverPass,
        setFormPanel,
        setOpenDrawer
      }}
    >
      {children}
    </DrawerContext.Provider>
  )
}

export const useDrawer = () => useContext(DrawerContext);